import React from 'react'

import Text, * as Text$ from '../Text'

export interface FieldLabelProps extends Text$.TextProps<HTMLLabelElement> {}
export function FieldLabel(props: FieldLabelProps) {
  return <Text as={'label'} bottom={'xs'} {...props} />
}
